import React from 'react'
import styled, { css } from 'styled-components'

const width = '17'
const height = '17'
const viewBox = '0 0 17 17'

const getDimensions = () => ({
  height,
  width
})

const getDimensionsCss = () => css`
  width: ${width}px;
  height: ${height}px;
`

const Image = styled.svg`
  ${({ noStyles }) => (!noStyles ? getDimensionsCss() : null)}
`

const defaultProps = {
  children: [
    <path
      fill="#1E4F67"
      d="M3.743 7.15a13.922 13.922 0 0 0 6.064 6.05l2.025-2.02a.916.916 0 0 1 .938-.22c1.03.34 2.144.523 3.285.523.506 0 .92.413.92.918v3.204a.922.922 0 0 1-.92.918C7.415 16.523.412 9.537.412.918.412.413.826 0 1.332 0h3.221c.506 0 .92.413.92.918 0 1.147.184 2.249.525 3.277a.92.92 0 0 1-.23.936l-2.025 2.02z"
      key="key-0"
    />
  ],
  viewBox
}

export default Object.assign(Image, {
  getDimensions,
  getDimensionsCss,
  defaultProps,
  displayName: 'IconPhone'
})
